'use client';
import {SplitFlagProvider} from '@gfiber/pixel-party';
import type {PropsWithChildren} from 'react';

export function SplitFeatureFlags({children}: PropsWithChildren) {
  return <SplitFlagProvider>{children}</SplitFlagProvider>;
}
